import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { Inputfiledsbase } from '../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../question-textbox';
import { DropdownservicesService } from '../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { MultiSelectQuestion } from '../../../question-multiselect';

@Injectable({
  providedIn: 'root',
})
export class AccordionPageService {
  compoTypeData: any = [];
  constructor(private dropdownservice: DropdownservicesService) {}

  loadDropdownData(code: string, dataArray: any[]) {
    let observable: Observable<any>;

    if (code === 'ACCORDION_DATA_TYPES') {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    } else {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }
    observable.subscribe((res: any) => {
      for (
        let i = 0;
        code === 'STATE_NAMES' ? i < res?.state?.length : i < res?.length;
        i++
      ) {
        let lookupname;
        if (code === 'ACCORDION_DATA_TYPES') {
          lookupname = res[i].name;
        } else {
          lookupname = res[i].lookup_name;
        }
        dataArray.push({
          id: code === 'STATE_NAMES' ? res.state[i].id : res[i].id,
          key: lookupname,
          value: code === 'STATE_NAMES' ? res.state[i].id : res[i].id,
        });
      }
    });
  }
  getCreateAccordionPage(): Observable<Inputfiledsbase<string>[]> {
    this.loadDropdownData('ACCORDION_DATA_TYPES', this.compoTypeData);
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'title',
        label: 'Title',
        required: true,
        order: 1,
      }),
      new TextboxQuestion({
        key: 'description',
        label: 'Description',
        required: false,
        order: 2,
      }),
      new MultiSelectQuestion({
        key: 'data',
        label: 'Data Type',
        required: true,
        options: this.compoTypeData,
        order: 3,
      }),
    ];
    return of(questions);
  }
  getLinkAccordionData(): Observable<Inputfiledsbase<string>[]> {
    const questions: Inputfiledsbase<string>[] = [
      new TextboxQuestion({
        key: 'link',
        label: 'Link',
        required: true,
      }),
    ];
    return of(questions);
  }
}
